/* Collection content is server rendered; without JavaScript every panel stays usable. */
if (!customElements.get('home-collections')) {
  customElements.define('home-collections', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const controls = this.querySelector('[data-home-tabs]');
      const tabs = Array.from(this.querySelectorAll('[data-home-tab]'));
      const panels = Array.from(this.querySelectorAll('[data-home-panel]'));
      if (!controls || !tabs.length || tabs.length !== panels.length) return;
      controls.setAttribute('role', 'tablist');
      controls.hidden = tabs.length < 2;
      tabs.forEach(tab => tab.setAttribute('role', 'tab'));
      panels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.tabIndex = 0;
        panel.querySelector('[data-home-panel-label]').hidden = true;
      });
      const select = index => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
      };
      select(0);
      this.addEventListener('click', event => {
        const index = tabs.indexOf(event.target.closest('[data-home-tab]'));
        if (index !== -1) select(index);
      });
      controls.addEventListener('keydown', event => {
        const current = tabs.indexOf(event.target);
        if (current === -1) return;
        let next;
        if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        select(next);
        tabs[next].focus();
      });
      // Keep the selected block visible when editing the theme in Shopify.
      this.addEventListener('shopify:block:select', event => {
        const index = panels.indexOf(event.target.closest('[data-home-panel]'));
        if (index !== -1) select(index);
      });
    }
  });
}
